import $ from 'jquery';
import { goToPage } from '~src/multipages';

export const handleChangePageBtn = (event) => {
  event.preventDefault();
  const pageIndex = $(event.currentTarget).data('page-index');

  if (event.target.id.startsWith('btn-page-delete-')) {
    return;
  }

  return goToPage(pageIndex);
};
